"use client";

import { c as _c } from "react/compiler-runtime";
import { useRouter } from "next/navigation";
import { AlertTriangle } from "lucide-react";
import { Button, Card, Chip } from "@heroui/react";
const NotFoundPage = () => {
  const $ = _c(4);
  const router = useRouter();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <AlertTriangle className="xs:size-40 size-32 sm:size-48 md:size-56 lg:size-64 xl:size-72" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Card.Content className="flex flex-col items-center justify-center gap-5">{t0}<div className="flex flex-col items-center justify-center gap-2"><Chip className="gap-1 whitespace-nowrap" color="default" size="lg" variant="soft">{"Not Found"}</Chip><h1 className="xs:text-3xl text-2xl font-medium sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl">Oh No! Error 404</h1><p className="text-default-500 max-w-sm text-center font-medium sm:max-w-lg">Sorry, the page you are looking for doesn’t exist or has been removed.</p></div></Card.Content>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== router.refresh) {
    t2 = <main className="flex h-full min-h-[calc(100vh-4rem)] w-full items-center justify-center"><Card className="m-5 w-full max-w-3xl px-2 py-16">{t1}<Card.Footer className="flex flex-col items-center justify-center gap-10"><Button onPress={router.refresh} size="lg" variant="ghost">{"Refresh"}</Button></Card.Footer></Card></main>;
    $[2] = router.refresh;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default NotFoundPage;